import { ICloseEvent, IMessageEvent, w3cwebsocket as W3CWebSocket } from 'websocket';

enum MessageType {
  SURVEY_SESSION_CREATED = 'SURVEY_SESSION_CREATED',
  SURVEY_SESSION_UPDATED = 'SURVEY_SESSION_UPDATED',
  SUBJECT_METADATA_UPDATED = 'SUBJECT_METADATA_UPDATED',
  SURVEY_SESSION_DELETED = 'SURVEY_SESSION_DELETED',
  SUBJECT_METADATA_DELETED = 'SUBJECT_METADATA_DELETED',
  USER_AGREED = 'USER_AGREED',
}

interface SurveyMessage {
  type: MessageType;
}

export interface SurveySocketClient {
  connected: boolean;
  subscribeOnSession: (callback: (subjectMetaId: string) => void) => void;
  subscribeOnAgreement: (callback: (subjectMetaId: string) => void) => void;
  subscribeOnMetadata: (callback: (subjectMetaId: string) => void) => void;
  subscribeOnDeleteSession: (callback: (subjectMetaId: string) => void) => void;
  subscribeOnDeleteUser: (callback: (subjectMetaId: string) => void) => void;
  onclose: (callback: () => void) => void;
  onConnect: (callback: () => void) => void;
  deactivate: () => void;
}

interface MessageListener {
  condition: (surveyMessage: SurveyMessage) => boolean;
  callback: (message: IMessageEvent) => void;
}
const NORMAL_CLOSURE_CODE = 1000;
class SurveySocketImpl implements SurveySocketClient {
  private _client: W3CWebSocket | undefined;
  connected: boolean = false;
  listeners: MessageListener[] = [];

  constructor(client?: W3CWebSocket) {
    if (client) {
    }
  }

  subscribeOnSession(callback: (subjectMetaId: string) => void) {
    if (this.connected) {
      this.listeners.push({
        condition: (surveyMessage: SurveyMessage) =>
          surveyMessage.type === MessageType.SURVEY_SESSION_CREATED ||
          surveyMessage.type === MessageType.SURVEY_SESSION_UPDATED,
        callback: (message: IMessageEvent) => {
          const { subjectMetaId } = JSON.parse(message.data as string);
          callback(subjectMetaId);
        },
      });
    }
  }

  subscribeOnAgreement(callback: (subjectMetaId: string) => void) {
    if (this.connected) {
      this.listeners.push({
        condition: (surveyMessage: SurveyMessage) => surveyMessage.type === MessageType.USER_AGREED,
        callback: (message: IMessageEvent) => {
          const { subjectMetaId } = JSON.parse(message.data as string);
          callback(subjectMetaId);
        },
      });
    }
  }

  subscribeOnMetadata(callback: (subjectMetaId: string) => void) {
    if (this.connected) {
      this.listeners.push({
        condition: (surveyMessage: SurveyMessage) => surveyMessage.type === MessageType.SUBJECT_METADATA_UPDATED,
        callback: (message: IMessageEvent) => {
          const { subjectMetaId } = JSON.parse(message.data as string);
          callback(subjectMetaId);
        },
      });
    }
  }
  subscribeOnDeleteSession(callback: (subjectMetaId: string) => void) {
    if (this.connected) {
      this.listeners.push({
        condition: (surveyMessage: SurveyMessage) => surveyMessage.type === MessageType.SURVEY_SESSION_DELETED,
        callback: (message: IMessageEvent) => {
          const { subjectMetaId } = JSON.parse(message.data as string);
          callback(subjectMetaId);
        },
      });
    }
  }
  subscribeOnDeleteUser(callback: (subjectMetaId: string) => void) {
    if (this.connected) {
      this.listeners.push({
        condition: (surveyMessage: SurveyMessage) => surveyMessage.type === MessageType.SUBJECT_METADATA_DELETED,
        callback: (message: IMessageEvent) => {
          const { subjectMetaId } = JSON.parse(message.data as string);
          callback(subjectMetaId);
        },
      });
    }
  }
  onclose(callback: () => void) {}
  onConnect(callback: () => void) {}

  deactivate() {}
}

export const SurveySocket = {
  connect: (token: string): SurveySocketClient => {
    const url = `${process.env.REACT_APP_SURVEY_SERVER_URL || 'localhost:8080'}`.replace('https', 'wss');
    const surveySocket = new SurveySocketImpl();
    return surveySocket;
  },
};
